
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/boost-wheels",
      function () {
        return require("private-next-pages/brands/boost-wheels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/boost-wheels"])
      });
    }
  